const reducer = (state: WtrState) => ({
  ...state,
  loading: true,
  slots: [],
  error: null,
});

export default reducer;
